import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const Exchangepolicy = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, []);
  return (
    <>
      <section style={{ paddingTop: "5rem" }}>
        <Container>
          <div className="policy">
            <div className="privacy">
              <h2>Exchange Policy</h2>
            </div>
            <h3> Eligibility for Exchange</h3>
            <p style={{ textIndent: "1.5rem" }}>
              Products purchased through www.VNEXTIT.in/Samsung.com can be
              exchanged under the following conditions:
            </p>
            <ul>
              <li>
                The product must be eligible for exchange as specified at the
                time of purchase.
              </li>
              <li>
                The product must be in its original condition, unused, and with
                all original packaging and accessories.
              </li>
              <li>
                Proof of purchase (order confirmation email or receipt) is
                required.
              </li>
            </ul>
            <h3>Exchange Process</h3>
            <ul>
              <li>
                Visit the Ovanctica platform, our trusted partner for processing
                exchanges.
              </li>
              <li>
                Log in using your company email address and follow the
                instructions provided on the Ovanctica site to initiate the
                exchange.
              </li>
              <li>
                Provide the necessary order details and reason for the exchange.
              </li>
            </ul>
            <h3>Conditions for Acceptance</h3>
            <ul>
              <li>
                The product is verified as meeting the exchange eligibility
                criteria.
              </li>
              <li>The request is made within the allowed timeframe.</li>
              <li>
                The product is received in its original condition by our
                exchange partner.
              </li>
            </ul>
            <h3>Exchange Fees</h3>
            <ul>
              <li>
                Depending on the circumstances, there may be a nominal fee for
                processing exchanges.
              </li>
              <li>
                Customers will be informed of any applicable fees before the
                exchange is confirmed.
              </li>
            </ul>
            <h3>Timeline for Exchange Completion</h3>
            <ul>
              <li>
                Once your exchange request is approved, you will be notified of
                the estimated time for processing and delivery of the
                replacement product.
              </li>
              <li>
                The replacement product will be dispatched as soon as the
                returned product is inspected and approved.
              </li>
            </ul>
            <h3>Exceptions</h3>
            <ul>
              <li>
                Certain items, such as custom or special-order products, may not
                be eligible for exchange.
              </li>
              <li>
                Products damaged due to misuse, improper handling, or
                unauthorized repairs are not covered under this policy.
              </li>
            </ul>
            <h3>Contact Us</h3>
            <p>
              For any questions regarding our exchange policy or assistance with
              your exchange process, please contact our support team at
              enquiry@vnextit.in.
            </p>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Exchangepolicy;
